// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 300px;
  background: #0f172a;
  padding: var(--spacing-xl);
  overflow-y: auto;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  height: 100vh;
  position: relative;
  border-right: 3px solid rgba(255, 255, 255, 0.1);
}

/* Light mode styles for sidebar */
:root[data-theme='light'] .sidebar {
  background: #ffffff;
  border-right: 3px solid #e2e8f0;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
}

.sidebar::after {
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 1px;
  background: linear-gradient(180deg, transparent, color-mix(in srgb, var(--color-primary) 50%, transparent), transparent);
}

:root[data-theme='light'] .sidebar::after {
  background: linear-gradient(180deg, transparent, rgba(59, 130, 246, 0.3), transparent);
}

.no-accounts-message {
  padding: 20px;
  text-align: center;
  color: var(--text-secondary);
  font-size: 14px;
}

@media (max-width: 768px) {
  .sidebar {
    position: fixed;
    left: -300px;
    transition: left 0.3s ease;
    z-index: 1000;
  }
  
  .sidebar.mobile-open {
    left: 0;
  }
}

.logo-container {
  display: flex;
  align-items: center;
  margin-bottom: var(--spacing-2xl);
  padding-bottom: var(--spacing-lg);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

:root[data-theme='light'] .logo-container {
  border-bottom: 1px solid #e2e8f0;
}

.logo {
  width: 56px;
  height: 56px;
  margin-right: var(--spacing-md);
  object-fit: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.sidebar h1 {
  color: white;
  font-size: var(--font-size-xl);
  margin: 0;
  font-weight: 700;
  letter-spacing: -0.02em;
}

:root[data-theme='light'] .sidebar h1 {
  color: #1e3a8a;
}

.sidebar .subtitle {
  color: #9ca3af;
  font-size: var(--font-size-sm);
  margin-top: var(--spacing-xs);
  opacity: 0.9;
}

:root[data-theme='light'] .sidebar .subtitle {
  color: #1e3a8a;
}

.account-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

/* Section label */
.account-list::before {
  content: 'ACCOUNTS';
  display: block;
  font-size: 12px;
  color: #cbd5e1;
  font-weight: 600;
  letter-spacing: 0.1em;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
}

:root[data-theme='light'] .account-list::before {
  color: #1e3a8a;
  border-bottom: 1px solid #e2e8f0;
}

.account-item {
  display: grid;
  grid-template-columns: 36px 1fr;
  align-items: start;
  padding: 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  width: 100%;
  text-decoration: none;
  margin-bottom: 1px;
}

:root[data-theme='light'] .account-item {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.account-item:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: color-mix(in srgb, var(--color-primary) 30%, transparent);
  transform: translateX(2px);
}

:root[data-theme='light'] .account-item:hover {
  background: #eff6ff;
  border-color: #93c5fd;
}

.account-item.active {
  background: rgba(255, 107, 53, 0.15);
  border-color: rgba(255, 107, 53, 0.6);
  padding-left: 13px;
  transform: none;
}

:root[data-theme='light'] .account-item.active {
  background: #dbeafe;
  border-color: #3b82f6;
}

.account-item.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--color-primary);
  border-radius: 0 2px 2px 0;
}

:root[data-theme='light'] .account-item.active::before {
  background: #3b82f6;
}

.account-item:active {
  opacity: 0.9;
}

.status-indicator-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 100%;
  align-self: center;
}

.status-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  position: relative;
}

.status-indicator::after {
  content: '';
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border-radius: 50%;
  background: inherit;
  opacity: 0.3;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.3;
  }
  50% {
    transform: scale(1.2);
    opacity: 0;
  }
}

.status-indicator.healthy { 
  background: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2), 0 0 8px rgba(16, 185, 129, 0.4);
}

.status-indicator.neutral { 
  background: #f59e0b;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2), 0 0 8px rgba(245, 158, 11, 0.4);
}

.status-indicator.unhealthy { 
  background: #ef4444;
  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2), 0 0 8px rgba(239, 68, 68, 0.4);
}

.status-indicator.unhealthy::after {
  animation: pulse 1s ease-in-out infinite;
}

.account-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;
  justify-content: flex-start;
}

.sidebar .account-name {
  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  text-align: left;
  width: 100%;
}

:root[data-theme='light'] .sidebar .account-name {
  color: #1e3a8a;
}

.account-status {
  color: #94a3b8;
  font-size: 13px;
  line-height: 1.3;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 4px;
  text-align: left;
  width: 100%;
}

:root[data-theme='light'] .account-status {
  color: #1e3a8a;
}

.account-status span {
  color: #718096;
}

:root[data-theme='light'] .account-status span {
  color: #1e3a8a;
}

.account-status strong {
  font-weight: 600;
  color: #cbd5e1;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.01em;
}

:root[data-theme='light'] .account-status strong {
  color: #1e3a8a;
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;EACV,wHAAwH;AAC1H;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,OAAO;EACT;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,iCAAiC;EACjC,iDAAiD;AACnD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,iDAAiD;EACjD,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uEAAuE;EACvE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".sidebar {\n  width: 300px;\n  background: #0f172a;\n  padding: var(--spacing-xl);\n  overflow-y: auto;\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);\n  height: 100vh;\n  position: relative;\n  border-right: 3px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Light mode styles for sidebar */\n:root[data-theme='light'] .sidebar {\n  background: #ffffff;\n  border-right: 3px solid #e2e8f0;\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);\n}\n\n.sidebar::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: linear-gradient(180deg, transparent, color-mix(in srgb, var(--color-primary) 50%, transparent), transparent);\n}\n\n:root[data-theme='light'] .sidebar::after {\n  background: linear-gradient(180deg, transparent, rgba(59, 130, 246, 0.3), transparent);\n}\n\n.no-accounts-message {\n  padding: 20px;\n  text-align: center;\n  color: var(--text-secondary);\n  font-size: 14px;\n}\n\n@media (max-width: 768px) {\n  .sidebar {\n    position: fixed;\n    left: -300px;\n    transition: left 0.3s ease;\n    z-index: 1000;\n  }\n  \n  .sidebar.mobile-open {\n    left: 0;\n  }\n}\n\n.logo-container {\n  display: flex;\n  align-items: center;\n  margin-bottom: var(--spacing-2xl);\n  padding-bottom: var(--spacing-lg);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n:root[data-theme='light'] .logo-container {\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.logo {\n  width: 56px;\n  height: 56px;\n  margin-right: var(--spacing-md);\n  object-fit: contain;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));\n  transition: transform 0.3s ease;\n}\n\n.logo:hover {\n  transform: scale(1.05);\n}\n\n.sidebar h1 {\n  color: white;\n  font-size: var(--font-size-xl);\n  margin: 0;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n:root[data-theme='light'] .sidebar h1 {\n  color: #1e3a8a;\n}\n\n.sidebar .subtitle {\n  color: #9ca3af;\n  font-size: var(--font-size-sm);\n  margin-top: var(--spacing-xs);\n  opacity: 0.9;\n}\n\n:root[data-theme='light'] .sidebar .subtitle {\n  color: #1e3a8a;\n}\n\n.account-list {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n/* Section label */\n.account-list::before {\n  content: 'ACCOUNTS';\n  display: block;\n  font-size: 12px;\n  color: #cbd5e1;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  text-align: center;\n}\n\n:root[data-theme='light'] .account-list::before {\n  color: #1e3a8a;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.account-item {\n  display: grid;\n  grid-template-columns: 36px 1fr;\n  align-items: start;\n  padding: 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  width: 100%;\n  text-decoration: none;\n  margin-bottom: 1px;\n}\n\n:root[data-theme='light'] .account-item {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n}\n\n.account-item:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: color-mix(in srgb, var(--color-primary) 30%, transparent);\n  transform: translateX(2px);\n}\n\n:root[data-theme='light'] .account-item:hover {\n  background: #eff6ff;\n  border-color: #93c5fd;\n}\n\n.account-item.active {\n  background: rgba(255, 107, 53, 0.15);\n  border-color: rgba(255, 107, 53, 0.6);\n  padding-left: 13px;\n  transform: none;\n}\n\n:root[data-theme='light'] .account-item.active {\n  background: #dbeafe;\n  border-color: #3b82f6;\n}\n\n.account-item.active::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: var(--color-primary);\n  border-radius: 0 2px 2px 0;\n}\n\n:root[data-theme='light'] .account-item.active::before {\n  background: #3b82f6;\n}\n\n.account-item:active {\n  opacity: 0.9;\n}\n\n.status-indicator-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 100%;\n  align-self: center;\n}\n\n.status-indicator {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.status-indicator::after {\n  content: '';\n  position: absolute;\n  top: -4px;\n  left: -4px;\n  right: -4px;\n  bottom: -4px;\n  border-radius: 50%;\n  background: inherit;\n  opacity: 0.3;\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 0.3;\n  }\n  50% {\n    transform: scale(1.2);\n    opacity: 0;\n  }\n}\n\n.status-indicator.healthy { \n  background: #10b981;\n  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2), 0 0 8px rgba(16, 185, 129, 0.4);\n}\n\n.status-indicator.neutral { \n  background: #f59e0b;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2), 0 0 8px rgba(245, 158, 11, 0.4);\n}\n\n.status-indicator.unhealthy { \n  background: #ef4444;\n  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2), 0 0 8px rgba(239, 68, 68, 0.4);\n}\n\n.status-indicator.unhealthy::after {\n  animation: pulse 1s ease-in-out infinite;\n}\n\n.account-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.sidebar .account-name {\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 1.3;\n  letter-spacing: -0.01em;\n  text-align: left;\n  width: 100%;\n}\n\n:root[data-theme='light'] .sidebar .account-name {\n  color: #1e3a8a;\n}\n\n.account-status {\n  color: #94a3b8;\n  font-size: 13px;\n  line-height: 1.3;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  text-align: left;\n  width: 100%;\n}\n\n:root[data-theme='light'] .account-status {\n  color: #1e3a8a;\n}\n\n.account-status span {\n  color: #718096;\n}\n\n:root[data-theme='light'] .account-status span {\n  color: #1e3a8a;\n}\n\n.account-status strong {\n  font-weight: 600;\n  color: #cbd5e1;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.01em;\n}\n\n:root[data-theme='light'] .account-status strong {\n  color: #1e3a8a;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
